export const getTrainingFolderTitle = (folder: string) => {
  if (folder === 'ASD') {
    return 'AutoScript Desktop Editor';
  }
  if (!folder) {
    return 'Training Videos';
  }
  return folder.charAt(0).toUpperCase() + folder.slice(1);
};
